export default __webpack_public_path__ + "static/media/private-label.e47bb31d.png";